<template>
  <div class="container-fluid">
    <Card>
      <template slot="header">
        <h3>امتیاز مشتریان</h3>
        <hr />
      </template>
      <template slot="content">
        <BnpGrid Selectable :Sortable="true" :IsReport="true" :HeaderReport="'امتیاز مشتریان '" ListCommaReport="['AmountContract']" :action="false" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
          <template slot="customerName" slot-scope="props">
            <span> {{ props.props.customerName }}</span> <span v-if="props.props.baygani">(بایگانی شده)</span>
          </template>
          <template slot="AmountContract" slot-scope="props">
            <span> {{ $Comma3ragham(props.props.AmountContract) }}</span>
          </template>
          <template slot="lastPresenter" slot-scope="props">
            <span>{{ props.props.lastPresenter + '--' + props.props.LasPDate }} </span>
          </template>
          <template slot="TotallScore" slot-scope="props">
            <!-- <b-progress :value="props.props.TotallScore" :max="propsRows[0].TotallScore" variant="warning"  show-progress animated></b-progress> -->
            <b-progress class="sidebarProgress mt-1" :title="props.props.TotallScore" show-value :variant="'warning'" :value="props.props.TotallScore" :max="propsRows[0].TotallScore" />
          </template>
          <template slot="CustomerCode" slot-scope="props">
                <a href="javascript:;" @click="$FindeCustomerById('DetailCustomer', props.props.Id, false, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.Id, false, $event)">{{ props.props.CustomerCode }}</a>
              </template>
        </BnpGrid>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      propsColumn: [
        { name: 'Id', label: 'کد', visibility: false },
        { name: 'CustomerCode', label: 'کد', visibility: true },
        { name: 'CustomerName', label: 'نام مشتری', visibility: true },
        { name: 'CodeBazaryabi', label: ' کد بازاریابی', visibility: true },
        { name: 'ScoreGrp37AxarinVazeit', label: 'امتیاز وضعیت نصب', visibility: true },
        { name: 'AmountContract', label: 'مبلغ کل قرارداد', visibility: true },
        { name: 'TotallScore', label: 'امتیاز کل', visibility: true },
        { name: 'lastPresenter', label: 'آخرین حضور', visibility: true },
      ],
      propsRows: [],
    }
  },
  created() {
    var DataAxios = { Action: 'reports/CustomerScore', Method: 'Get', ArryfildValue: null }
    this.$PostData(DataAxios).then((result) => {
      this.propsRows = result.ListCustomerScore
      this.$store.state.renderComponentGrid = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
      })
    })
  },
  components: { Card, BnpGrid },
}
</script>
